import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { HomePageSEO } from '@/components/seo/SEOHead';
import HomeNavbar from '@/components/homepage/HomeNavbar';
import HomeHero from '@/components/homepage/HomeHero';
import HomeProductMockup from '@/components/homepage/HomeProductMockup';
import HomeValueProps from '@/components/homepage/HomeValueProps';
import HomeTractionMetrics from '@/components/homepage/HomeTractionMetrics';
import HomeTestimonials from '@/components/homepage/HomeTestimonials';
import HomeFAQ from '@/components/homepage/HomeFAQ';
import HomeFinalCTA from '@/components/homepage/HomeFinalCTA';
import HomeFooter from '@/components/homepage/HomeFooter';
import IntentModal from '@/components/shared/IntentModal';

const HomePage = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [showIntentModal, setShowIntentModal] = useState(false);

  // Redirect authenticated users to dashboard; ad traffic to /ad
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
      return;
    }

    // Detect ad/marketing params and redirect to /ad landing page
    const params = new URLSearchParams(window.location.search);
    const AD_PARAMS = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_adset', 'utm_ad', 'utm_content',
      'gclid', 'fbclid', 'li_fat_id',
    ];
    const hasAdParams = AD_PARAMS.some((key) => params.has(key));
    if (hasAdParams) {
      navigate(`/ad?${params.toString()}`, { replace: true });
    }
  }, [user, loading, navigate]);
  
  const handleCTA = () => {
    setShowIntentModal(true);
  };

  const handleIndividualSelect = () => {
    setShowIntentModal(false);
    navigate('/m3-register');
  };

  const handleBusinessSelect = () => {
    setShowIntentModal(false);
    navigate('/business#pricing');
  };
  
  return (
    <>
      <HomePageSEO />
      <div className="min-h-screen bg-white">
        <IntentModal
          isOpen={showIntentModal}
          onClose={() => setShowIntentModal(false)}
          onIndividualSelect={handleIndividualSelect}
          onBusinessSelect={handleBusinessSelect}
        />
        <HomeNavbar onCTA={handleCTA} />
        <HomeHero onCTA={handleCTA} />
        <HomeProductMockup />
        <HomeValueProps />
        <HomeTractionMetrics />
        <HomeTestimonials />
        <HomeFAQ />
        <HomeFinalCTA onCTA={handleCTA} />
        <HomeFooter />
      </div>
    </>
  );
};

export default HomePage;
